import React, { useEffect, useState } from "react";
import DashboardHeader from "./Components/DashboardHeader/DashboardHeader";
import DashboardPatientListTable from "./Components/Tables/DashboardPatientListTable";
import { FetchDashboardProps, fetchDashboardList } from "../../Store/Dashboard/DashboardAPI";
import { APIResponseType } from "../../Services/Models/Async/AsyncModel";
import { toastError, toastInfo } from "../../Methods/Helpers/ToastHelper";
import { DashboardListItems } from "../../Store/Dashboard/types";
import { OrderDateSorting } from "../../Methods/Dashboard/SortingAndFilters/SortingMethods";
import { BrowserHistory } from "../../Utils/BrowserHistory";
import { useNavigate } from "react-router";


const Dashboard = () => {
  const navigate = useNavigate();
  const [patientList, setPatientList] = useState<Array<DashboardListItems>>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [pageNumber, setPageNumber] = useState<number>(1)
  const [totalRecords, setTotalRecords] = useState<number>()
  const PATIENT_LIST_PAGE_SIZE = 20

  useEffect(() => {
    fetchProviderPatientList({ page_number: pageNumber, page_size: PATIENT_LIST_PAGE_SIZE });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNumber]);


  //Old Logic : 
  const fetchProviderPatientList = async ({ page_number, page_size }: FetchDashboardProps) => {
    setIsLoading(true);
    await fetchDashboardList({ page_number, page_size }).then((response: APIResponseType<any>) => {
      if (response.success) {
        console.log(response.data, "======response.data");
        if (response.data.length > 0) {
          setPatientList(OrderDateSorting(response.data));
          setTotalRecords(response.pagination?.total_records)
        } else {
          const ifNotFirstTime = localStorage.getItem("ifNotFirstTime");
          if (ifNotFirstTime !== "1") {
            toastInfo("There are no orders yet, please order kiddo for your patient(s).");
            localStorage.setItem("ifNotFirstTime", "1");
            BrowserHistory.replace("/dashboard");
            navigate("/addpatientleads");
          }
        }
      } else {
        setPatientList([]);
        toastError(response.message);
      }
      setIsLoading(false);
    }).catch((error: any) => {
      setPatientList([]);
      toastError(error.message);
      setIsLoading(false);
    });
  }


  // const onAlertClick = (id: number) => {
  //   navigate(`/patientprofile/${id}`)
  // }


  return (
    <>
      <div className="main-wrapper home-page">
        <div className="page-inner">
          <DashboardHeader tableData={patientList} searchApply={(data: any) => setPatientList(data)} isBackButton={false} isLoading={isLoading} />
        </div>
        <div className="cards-wrap">
          {/* <div className="d-flex align-items-center legends mt-3 mb-3 ps-4">
            <span className="label label-status">Patient Status:</span>
            <div className="group-indicator d-flex align-items-center">
              <div className="lagend-indicate normal">
                <span className="color green"> </span>
                <span className="label">Normal</span>
              </div>
              <div className="lagend-indicate cautions">
                <span className="color yellow"></span>
                <span className="label">Cautions</span>
              </div>
              <div className="lagend-indicate criticale">
                <span className="color red"></span>
                <span className="label">Critical</span>
              </div>
            </div>
          </div> */}
          <div className="table-struct-02">
            <DashboardPatientListTable
              tableData={patientList.length > 0 ? patientList : []}
              customClass=""
              TableType="success"
              rowsPerPage={PATIENT_LIST_PAGE_SIZE}
              loading={isLoading}
              dataLength={totalRecords}
              setPageNumber={setPageNumber}
              page_number={pageNumber}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
